export var ReportGroupVisibilityStatus;
(function (ReportGroupVisibilityStatus) {
    ReportGroupVisibilityStatus["ALL"] = "ALL";
    ReportGroupVisibilityStatus["HIDDEN"] = "HIDDEN";
    ReportGroupVisibilityStatus["VISIBLE"] = "VISIBLE";
})(ReportGroupVisibilityStatus || (ReportGroupVisibilityStatus = {}));
